import { DotLegalLink } from "@dotlegal/dotlegal-ui-components";

interface RiskCountCellLinkProps {
    count: number;
    onClick: () => void;
    // A zero count is either shown as plain, non-clickable "0" text (documentation) or as a blank cell
    // (linked controls, matching the status cell which is also blank then).
    showZero?: boolean;
}

// A count cell in the risk overviews: a count of one or more is a clickable link that opens the count's
// dialog; a zero count is blank or plain text depending on showZero.
function RiskCountCellLink({ count, onClick, showZero = false }: RiskCountCellLinkProps) {
    if (count === 0) return showZero ? <>{count}</> : null;

    return (
        <DotLegalLink onClick={onClick} linkColor="primary" bold stopPropagation>
            {count.toString()}
        </DotLegalLink>
    );
}

export default RiskCountCellLink;
